<template>
  <div class="netpa-accounts-chart">
    <div class="netpa-accounts-chart__canvas">
      <apexchart
        :key="chartdata"
        :height="chartHeight"
        width="100%"
        :options="ApexChartOptions"
        :series="ApexChartOptions.series"
      ></apexchart>
    </div>
    <div class="netpa-accounts-chart__summary text-center font-weight-bold">
      <p class="mb-1">مجموع مانده حساب ها</p>
      <p class="mb-0">{{ $Comma3ragham(sumMande) }} <span>ریال</span></p>
    </div>
  </div>
</template>
<script>
export default {
  name: "AccountsChart",
  data() {
    return {
      chartdata: 0,
      sumMande: 0,
      chartHeight: 280,
      ApexChartOptions: {
        chart: {
          type: "pie",
          fontFamily: "IRANSans, Tahoma, Arial",
        },
        legend: {
          position: "bottom",
          fontSize: "11px",
          itemMargin: {
            horizontal: 6,
            vertical: 2,
          },
        },
        dataLabels: {
          enabled: true,
          style: {
            fontWeight: "normal",
            colors: ["#000"],
            fontSize: "11px",
          },
        },
        colors: [
          "#FF595E",
          "#FFCA3A",
          "#8AC926",
          "#FF924C",
          "#C77DFF",
          "#F72585",
          "#B5179E",
          "#2EC4B6",
          "#9B5DE5",
          "#F15BB5",
          "#00BBF9",
        ],
        states: {
          hover: {
            filter: {
              type: "lighten",
              value: 0.05,
            },
          },
          active: {
            filter: {
              type: "lighten",
              value: 0.03,
            },
          },
        },
        series: [],
        labels: [],
        stroke: {
          show: false,
        },
        tooltip: {
          theme: "light",
          style: {
            color: "#000",
            fontSize: "12px",
            fontFamily: "IRANSans, Tahoma, Arial",
          },
          y: {
            formatter: function (val) {
              return Number(val || 0).toLocaleString("en-US");
            },
          },
        },
      },
    };
  },
  methods: {
    updateChartHeight() {
      const width = window.innerWidth;
      if (width < 768) {
        this.chartHeight = 260;
      } else if (width <= 991) {
        this.chartHeight = 320;
      } else {
        this.chartHeight = 280;
      }
    },
    GetAcconts() {
      var DataAxiosRow = {
        ArryfildValue: "",
        Method: "Post",
        Action: "ListTaahodat",
        Token: this.$session.get("TokenNetPa"),
      };
      const formData = new FormData();
      formData.append(
        "wwwtblAzaId",
        this.$session.get("UserInfoNetPa").wwwtblAzaId,
      );
      formData.append("wwwtblSarfaslTypeId", 2);
      DataAxiosRow.ArryfildValue = formData;
      this.$PostFormData(DataAxiosRow).then((data) => {
        data.forEach((element) => {
          element.mande = element.mande + element.sumMabTaeedNaShode;
          this.ApexChartOptions.labels.push(element.desNoe);
          this.ApexChartOptions.series.push(element.mande);
          this.sumMande += element.mande;
        });
      });
    },
    handleResize() {
      this.updateChartHeight();
    },
  },
  created() {
    this.updateChartHeight();
    this.GetAcconts();
  },
  mounted() {
    window.addEventListener("resize", this.handleResize);
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.handleResize);
  },
};
</script>
<style scoped>
.netpa-accounts-chart {
  width: 100%;
}

.netpa-accounts-chart__canvas {
  width: 100%;
  min-height: 260px;
}

.netpa-accounts-chart__summary {
  margin-top: 0.75rem;
  padding-top: 0.5rem;
  border-top: 1px solid rgba(42, 63, 84, 0.08);
  color: #2a3f54;
}

@media (min-width: 768px) and (max-width: 991px) {
  .netpa-accounts-chart__canvas {
    min-height: 320px;
  }
}
</style>
